export class KafkaSourcePropertiesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "source",
            "baseName": "source",
            "type": "KafkaSourceConfig",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfigInput",
            "format": ""
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfigInput",
            "format": ""
        },
        {
            "name": "partitioning",
            "baseName": "partitioning",
            "type": "KafkaPartitioningConfig",
            "format": ""
        },
        {
            "name": "batch",
            "baseName": "batch",
            "type": "KafkaBatchConfig",
            "format": ""
        },
        {
            "name": "errorHandling",
            "baseName": "errorHandling",
            "type": "KafkaErrorHandlingConfig",
            "format": ""
        },
        {
            "name": "compaction",
            "baseName": "compaction",
            "type": "IcebergCompactionConfig",
            "format": ""
        },
        {
            "name": "schemaOverrides",
            "baseName": "schemaOverrides",
            "type": "KafkaSchemaOverridesConfig",
            "format": ""
        },
        {
            "name": "flinkConfigOverrides",
            "baseName": "flinkConfigOverrides",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSourcePropertiesInput.attributeTypeMap;
    }
    constructor() {
    }
}
